import React, { useState } from 'react';
import Modal from '../../../Components/Modal';
import { TYPE_OPTIONS, typeLabel } from '../businessType';
import './SizeFilter.css';

/* Business-type picker for the sidebar: chips for what's chosen, and a modal
 * of toggles (26 is too many to show in the sidebar). Keep traders in ANY
 * chosen type. Nothing selected = any. */
const BusinessTypeFilter = ({ value = [], onChange }) => {
    const [open, setOpen] = useState(false);
    const toggle = (key) =>
        onChange(value.includes(key) ? value.filter((k) => k !== key) : [...value, key]);
    return (
        <>
            {value.length > 0 && (
                <div className="tags" style={{ marginBottom: 6 }}>
                    {value.map((k) => (
                        <span key={k} className="tag-chip muted">
                            <span className="commodity-pill-text">{typeLabel(k)}</span>
                            <button type="button" aria-label="Remove" onClick={() => toggle(k)}>
                                ×
                            </button>
                        </span>
                    ))}
                </div>
            )}
            <button
                type="button"
                className="btn btn-secondary btn-block commodity-picker-btn"
                onClick={() => setOpen(true)}
            >
                {value.length === 0 ? 'Any business type' : `${value.length} selected — edit`}
            </button>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                title="Business type"
                width="560px"
                footer={
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <button type="button" className="btn btn-secondary" onClick={() => onChange([])}>
                            Clear
                        </button>
                        <button type="button" className="btn btn-primary" onClick={() => setOpen(false)}>
                            Done
                        </button>
                    </div>
                }
            >
                <p className="business-type-note">
                    From the company&rsquo;s Companies House activity codes. Traders not on Companies
                    House have no type, so they drop out when you pick one.
                </p>
                <div className="size-filter business-type-grid" role="group" aria-label="Business type">
                    {TYPE_OPTIONS.map((o) => (
                        <button
                            key={o.key}
                            type="button"
                            aria-pressed={value.includes(o.key)}
                            className={value.includes(o.key) ? 'on' : ''}
                            onClick={() => toggle(o.key)}
                        >
                            {o.label}
                        </button>
                    ))}
                </div>
            </Modal>
        </>
    );
};

export default BusinessTypeFilter;
